// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LbiS","content":"styles_content__2ZKzC","row":"styles_row__eIZdf","footer":"styles_footer__1kDBX","phraseLength":"styles_phraseLength__ZXAx6"};